/**
 * Utilidades de fecha específicas para Forecast Metrics
 * Funciones puras para manejo y formateo de fechas
 */

import { format } from 'date-fns';
import { getWeek } from '../components/forecast_metrics-components/week_number.js';

/**
 * Formatea una fecha a formato DateTime para CQL
 * @param {Date} date - Fecha a formatear
 * @returns {string} - Fecha formateada como 'YYYY-MM-DD HH:mm:ss'
 */
export const formatDateTime = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d} 00:00:00`;
};

/**
 * Obtiene la fecha de ayer formateada
 * @returns {string} - Fecha de ayer en formato 'YYYY-MM-DD HH:mm:ss'
 */
export const getYesterdayFormatted = () => {
  const ayer = new Date();
  ayer.setDate(ayer.getDate() - 1);
  ayer.setHours(0, 0, 0, 0);
  return formatDateTime(ayer);
};

/**
 * Calcula el rango de fechas mínima y máxima para un día específico
 * @param {string} cqlFecha - Fecha base en formato 'YYYY-MM-DD HH:mm:ss'
 * @returns {Object} - Objeto con cqlFechaMin y cqlFechaMax
 */
export const calculateForecastDateRange = (cqlFecha) => {
  const datePart = cqlFecha.split(' ')[0]; // Solo la parte de la fecha
  return {
    cqlFechaMin: `${datePart} 00:00:00`,
    cqlFechaMax: `${datePart} 23:00:00`
  };
};

/**
 * Obtiene el número de semana para una fecha específica
 * @param {string} cqlFecha - Fecha en formato 'YYYY-MM-DD HH:mm:ss'
 * @returns {number} - Número de semana
 */
export const getForecastWeekNumber = (cqlFecha) => {
  return getWeek(new Date(cqlFecha));
};

/**
 * Formatea una fecha usando date-fns
 * @param {Date} fecha - Fecha a formatear
 * @returns {string} - Fecha formateada como 'yyyy-MM-dd HH:mm:ss'
 */
export const formatForecastDate = (fecha) => {
  return format(fecha, 'yyyy-MM-dd HH:mm:ss');
};

/**
 * Combina fecha y hora en un string DateTime
 * @param {string} selectedDate - Fecha seleccionada
 * @param {string} selectedTime - Hora seleccionada
 * @returns {string} - DateTime combinado
 */
export const combineForecastDateTime = (selectedDate, selectedTime) => {
  if (!selectedDate || !selectedTime) return '';
  return `${selectedDate} ${selectedTime}`;
};
